import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { Formik, Form, ErrorMessage } from "formik";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import "./styles.css";
import ResponsiveAppBar from "../../components/AppBar";
import { useLocation } from "react-router-dom";
import { createCompany, sendInvitations } from "../../services/company";
import { toast } from "react-toastify";
import validationSchema from "./schema";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../services/user";

const FormWorkspace = () => {
  const location = useLocation();
  const userProfile = location.state.profile;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const myStyle = {
    padding: "10px",
    paddingBottom: "20px",
    borderRadius: "5px",
    marginBottom: "20px",
    marginTop: "10px",
  };

  const initialValues = {
    workspaceName: "",
    emails: [],
  };

  useEffect(() => {
    if (userProfile.company) {
      navigate("/home-page", {
        state: { profile: userProfile },
      });
    }
  }, [userProfile, navigate]);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);

      const companyData = {
        userId: userProfile._id,
        name: values.workspaceName,
      };
      await createCompany(companyData).then(async (response) => {
        toast.success("Espacio de trabajo creado correctamente");

        if (values.emails.length !== 0) {
          const invitationInfo = {
            companyId: response._id,
            invitedBy: userProfile._id,
            companyName: response.name,
            email: values.emails,
          };

          try {
            await sendInvitations(invitationInfo);
            toast.success("Invitaciones enviadas correctamente");
          } catch (error) {
            toast.error("Ocurrio un error al enviar las invitaciones");
          }
        }

        await getUserById(userProfile._id).then((response) => {
          navigate("/home-page", {
            state: { profile: response },
          });
        });

        // Redirigir al usuario a la página de formulario de espacio de trabajo
      });
    } catch (error) {
      console.error("Error creating company:", error);
    }

    setIsLoading(false);
    // Luego, podrías redirigir al usuario a otra página, si es necesario
  };

  return (
    <>
      <ResponsiveAppBar fullName={userProfile.profile.fullname} />
      <Container
        maxWidth="sm"
        style={{ marginTop: "64px", textAlign: "center" }}
      >
        <Typography variant="h6" gutterBottom>
          Creá tu Workspace en GerenUC
        </Typography>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            setFieldValue,
            touched,
          }) => (
            <Form className="form" onSubmit={handleSubmit}>
              <TextField
                name="workspaceName"
                label="Nombre del Workspace"
                variant="outlined"
                fullWidth
                value={values.workspaceName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.workspaceName && !!errors.workspaceName}
                helperText={<ErrorMessage name="workspaceName" />}
              />
              <ReactMultiEmail
                placeholder="Invite a colaboradores por mail"
                style={{
                  ...myStyle,
                  ...(values.isEmailFieldFocused && {
                    border: "1px solid #75BD1D", // Cambiar el color del borde cuando está enfocado
                  }),
                }}
                emails={values.emails}
                onChange={(emails) => setFieldValue("emails", emails)}
                onFocus={() => setFieldValue("isEmailFieldFocused", true)}
                onBlur={() => setFieldValue("isEmailFieldFocused", false)}
                autoFocus={true}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index}>
                      <div data-tag-item>{email}</div>
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>
                  );
                }}
              />
              {isLoading ? (
                <CircularProgress />
              ) : (
                <Button type="submit" variant="contained" color="primary">
                  Crear Espacio de Trabajo
                </Button>
              )}
            </Form>
          )}
        </Formik>
      </Container>
    </>
  );
};

export default FormWorkspace;
